export const default_emoji_data = {
  日记: '📔',
  Diary: '📔',
  读书: '📖',
  读书笔记: '📖',
  微信读书: '📖',
  书单: '📖',
  阅读: '📖',
  得到: '📖',
  好书: '📖',
  kindle: '📖',
  book: '📖',
  Reading: '📖',
  照片: '📷',
  图片: '📷',
  相册: '📷',
  photo: '📷',
  金句: '💬',
  句子: '💬',
  名言: '💬',
  警句: '💬',
  鸡汤: '💬',
  摘抄: '💬',
  碎碎念: '💬',
  工作: '💼',
  会议: '💼',
  复盘: '💼',
  职场: '💼',
  work: '💼',
  美食: '🍳',
  做饭: '🍳',
  食物: '🍳',
  早餐: '🍳',
  午餐: '🍳',
  晚餐: '🍳',
  food: '🍳',
  代码: '⌨️',
  编程: '⌨️',
  code: '⌨️',
  好玩: '🤣',
  好笑: '🤣',
  幽默: '🤣',
  有趣: '🤣',
  段子: '🤣',
  笑话: '🤣',
  健康: '🏃🏻',
  运动: '🏃🏻',
  健身: '🏃🏻',
  减肥: '🏃🏻',
  主意: '💡',
  创意: '💡',
  头脑风暴: '💡',
  想法: '💡',
  灵感: '💡',
  点子: '💡',
  思考: '💡',
  收件夹: '📥',
  收件箱: '📥',
  待办: '✅',
  清单: '✅',
  任务: '✅',
  资料: '🗄',
  资料库: '🗄',
  资源: '🗄',
  投资: '📈',
  股票: '📈',
  基金: '📈',
  有知有行: '📈',
  育儿: '👶🏻',
  宝宝: '👶🏻',
  孩子: '👶🏻',
  产品经理: '🧱',
  产品: '🧱',
  电影: '📽',
  影视: '📽',
  音乐: '🎧',
  听歌: '🎧',
  歌曲: '🎧',
  学习: '📚',
  成长: '📚',
  文献笔记: '📚',
  猫: '🐱',
  猫咪: '🐱',
  植物: '🌱',
  成长: '🌱',
  游戏: '🎮',
  电子游戏: '🎮',
  旅游: '🗺',
  旅行: '🗺',
  出国: '🗺',
  写作: '✍️',
  写文章: '✍️',
  思维: '🧠',
  思考: '🧠',
  思维方式: '🧠',
  认知: '🧠',
  生活: '🏡',
  当下: '🧘🏻',
  现在: '🧘🏻',
  觉察: '🧘🏻',
  三省吾身: '🧘🏻',
  NOW: '🧘🏻',
  工具: '🛠',
  商业: '🛫',
  情绪: '🤭',
  心情: '🤭',
  捷径: '📱',
  快捷指令: '📱',
  捷径输入: '📱',
  梦: '🛌',
}
